import { useApdmImport } from '@euler/functions/apdm/import/useApdmImport';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useState } from 'react';
import { ScrollView } from 'react-native';
import { useTheme } from 'styled-components';
import { ApdmUploadButton } from '../../ApdmUploadButton';
import { ReviewSection } from '../../ReviewControls';
import { ImportCard } from '../import-card';
import { ImportsList } from '../imports-list';

/**
 * Upload a file, watch it being read, look at the summary, start it. Earlier
 * imports sit below.
 */
export function ImportWorkspace({ importId }: { importId: string | null }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const controller = useApdmImport(importId);
  const [listVersion, setListVersion] = useState(0);
  const { state } = controller;
  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: theme.page.background }}
      contentContainerStyle={{ padding: rpx(16) }}
    >
      <ReviewSection
        title="导入服务记录"
        description="上传门店系统导出的服务记录、工单或结算单（Excel 或 CSV），系统会自动整理，确认后开始导入。"
      >
        <ApdmUploadButton
          disabled={controller.pending !== null}
          onUploaded={async attachment => {
            await controller.actions.upload(attachment);
            setListVersion(version => version + 1);
          }}
        />
      </ReviewSection>
      <ImportCard
        controller={controller}
        onDeleted={() => {
          controller.actions.open(null);
          setListVersion(version => version + 1);
        }}
      />
      <ImportsList
        selectedImportId={state?.id ?? null}
        // The open import moving on changes its row too.
        reloadKey={`${listVersion}:${state?.id}:${state?.kind}`}
        onOpen={controller.actions.open}
      />
    </ScrollView>
  );
}
